import {
  cityValidation,
  stateValidation,
  streetValidation,
  zipValidation
} from "../../utils/testFns";

export const homeStreetValidation = (labels) =>
  streetValidation({ scope: "home", labels });

export const homeCityValidation = (labels) =>
  cityValidation({ scope: "home", labels });

export const homeStateValidation = (labels) =>
  stateValidation({ scope: "home", labels });

export const homeZipValidation = (labels) =>
  zipValidation({ scope: "home", labels });

export const mailingStreetValidation = (labels) =>
  streetValidation({
    scope: "mailing",
    labels
  });

export const mailingCityValidation = (labels) =>
  cityValidation({ scope: "mailing", labels });

export const mailingStateValidation = (labels) =>
  stateValidation({ scope: "mailing", labels });

export const mailingZipValidation = (labels) =>
  zipValidation({ scope: "mailing", labels });
